
import React from 'react'
import Bannerspage from "./Bannerspage";
import Newscreen from "./Newscreen";
import Aboutsubscription from "./Aboutsubscription";
import "./Homes.css";
import { Link } from "react-router-dom";

function Foodsubscriptionpage() {
    return (
        <div>
            <div className=' home-banner-scrolling'
                style={{
                    // marginTop: "105px",
                    marginBottom: "50px",
                    overflow: "auto",
                    scrollbarWidth: "none",
                    width: "100vw",
                    marginLeft: 0,
                    padding: 0
                }}>
                <div style={{ width: "100%" }}>
                    <Bannerspage />
                </div>
                <div style={{ width: "100%" }}>
                    <Aboutsubscription />
                    <Newscreen />
                </div>
                <br></br>
            </div>
        </div>
    )
}

export default Foodsubscriptionpage


